import { AxiosResponse } from 'axios';
import apiClient from '../api/apiClient';
import {
  ApiResponse,
  BasicSettings,
  BasicSettingsRequest,
} from '../../types/admin';

// ===== 홈 기본 설정 관련 API =====

// 기본 설정 조회
export const getBasicSettings = async (): Promise<BasicSettings> => {
  try {
    // console.log('기본 설정 조회 요청:', {
    //   url: '/api/admin/ui/basic'
    // });

    const response: AxiosResponse<ApiResponse<BasicSettings>> = await apiClient.get('/api/admin/ui/basic');

    /// console.log('기본 설정 조회 응답:', {response});

    return response.data.data;
  } catch (error: any) {
    //  console.error('기본 설정 조회 실패:', {
    //   message: error.message,
    //   status: error.response?.status,
    //   statusText: error.response?.statusText,
    //   data: error.response?.data
    // });

    let errorMessage = '기본 설정 조회에 실패했습니다.';
    
    if (!error.response) {
      errorMessage = '서버에 연결할 수 없습니다. 네트워크를 확인해주세요.';
    } else if (error.response.status === 401) {
      errorMessage = '인증이 필요합니다. 다시 로그인해주세요.';
    } else if (error.response.status === 403) {
      errorMessage = '관리자 권한이 필요합니다.';
    } else if (error.response.status >= 500) {
      errorMessage = '서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.';
    }
    
    throw new Error(errorMessage);
  }
};

// 기본 설정 등록
export const createBasicSettings = async (settingsData: BasicSettingsRequest): Promise<BasicSettings> => {
  try {
    // console.log('기본 설정 등록 요청:', {
    //   url: '/api/admin/ui/basic',
    //   data: settingsData
    // });

    const formData = new FormData();
    if (settingsData.favicon) {
      formData.append('favicon', settingsData.favicon);
      // SVG 파일인 경우 타입 정보 추가
      if (settingsData.favicon.name.toLowerCase().endsWith('.svg')) {
        formData.append('faviconType', 'image/svg+xml');
      }
    }
    if (settingsData.headerLogo) {
      formData.append('headerLogo', settingsData.headerLogo);
      // SVG 파일인 경우 타입 정보 추가
      if (settingsData.headerLogo.name.toLowerCase().endsWith('.svg')) {
        formData.append('headerLogoType', 'image/svg+xml');
      }
    }
    formData.append('webName', settingsData.webName);
    if (settingsData.adminProfileImage) {
      formData.append('adminProfileImage', settingsData.adminProfileImage);
      // SVG 파일인 경우 타입 정보 추가
      if (settingsData.adminProfileImage.name.toLowerCase().endsWith('.svg')) {
        formData.append('adminProfileImageType', 'image/svg+xml');
      }
    }

    const response: AxiosResponse<ApiResponse<BasicSettings>> = await apiClient.post('/api/admin/ui/basic', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    /// console.log('기본 설정 등록 응답:', {response});

    return response.data.data;
  } catch (error: any) {
    // console.error('기본 설정 등록 실패:', {
    //   message: error.message,
    //   status: error.response?.status,
    //   statusText: error.response?.statusText,
    //   data: error.response?.data
    // });

    let errorMessage = '기본 설정 등록에 실패했습니다.';
    
    if (!error.response) {
      errorMessage = '서버에 연결할 수 없습니다. 네트워크를 확인해주세요.';
    } else if (error.response.status === 400) {
      errorMessage = error.response.data?.message || '잘못된 요청입니다.';
    } else if (error.response.status === 401) {
      errorMessage = '인증이 필요합니다. 다시 로그인해주세요.';
    } else if (error.response.status === 403) {
      errorMessage = '관리자 권한이 필요합니다.';
    } else if (error.response.status >= 500) {
      errorMessage = '서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.';
    }
    
    throw new Error(errorMessage);
  }
};

// 기본 설정 수정
export const updateBasicSettings = async (id: number, settingsData: BasicSettingsRequest): Promise<BasicSettings> => {
  try {
    //  console.log('기본 설정 수정 요청:', {
    //   url: `/api/admin/ui/basic/${id}`,
    //   data: settingsData
    // });

    const formData = new FormData();
    if (settingsData.favicon) {
      formData.append('favicon', settingsData.favicon);
      // SVG 파일인 경우 타입 정보 추가
      if (settingsData.favicon.name.toLowerCase().endsWith('.svg')) {
        formData.append('faviconType', 'image/svg+xml');
      }
    }
    if (settingsData.headerLogo) {
      formData.append('headerLogo', settingsData.headerLogo);
      // SVG 파일인 경우 타입 정보 추가
      if (settingsData.headerLogo.name.toLowerCase().endsWith('.svg')) {
        formData.append('headerLogoType', 'image/svg+xml');
      }
    }
    formData.append('webName', settingsData.webName);
    if (settingsData.adminProfileImage) {
      formData.append('adminProfileImage', settingsData.adminProfileImage);
      // SVG 파일인 경우 타입 정보 추가
      if (settingsData.adminProfileImage.name.toLowerCase().endsWith('.svg')) {
        formData.append('adminProfileImageType', 'image/svg+xml');
      }
    }

    const response: AxiosResponse<ApiResponse<BasicSettings>> = await apiClient.patch(`/api/admin/ui/basic/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    /// console.log('기본 설정 수정 응답:', {response });

    return response.data.data;
  } catch (error: any) {
    // console.error('기본 설정 수정 실패:', {
    //   message: error.message,
    //   status: error.response?.status,
    //   statusText: error.response?.statusText,
    //   data: error.response?.data
    // });

    let errorMessage = '기본 설정 수정에 실패했습니다.';
    
    if (!error.response) {
      errorMessage = '서버에 연결할 수 없습니다. 네트워크를 확인해주세요.';
    } else if (error.response.status === 400) {
      errorMessage = error.response.data?.message || '잘못된 요청입니다.';
    } else if (error.response.status === 401) {
      errorMessage = '인증이 필요합니다. 다시 로그인해주세요.';
    } else if (error.response.status === 403) {
      errorMessage = '관리자 권한이 필요합니다.';
    } else if (error.response.status === 404) {
      errorMessage = '기본 설정을 찾을 수 없습니다.';
    } else if (error.response.status >= 500) {
      errorMessage = '서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.';
    }
    
    throw new Error(errorMessage);
  }
};
